export default {
  adjustViewSize() {
    var adminBarHeight = jQuery('#wpadminbar').outerHeight();
    var navBarHeight = jQuery('#header').outerHeight();
    var screenHeight = jQuery(window).height();
    jQuery('.cart .main').height(screenHeight - navBarHeight - adminBarHeight);
  },
  initView() {   
    jQuery('.quantity-wrapper input').attr('readonly', true);
    jQuery('.coupon-wrapper button').text('').addClass('fas fa-check');
  },
  init() {
    jQuery(document).on('updated_cart_totals', this.initView);
    this.initView();

    jQuery(document).on('click', '#coupon-trigger', function() {     
      if (jQuery('.coupon-wrapper').is(':visible')) { 
        jQuery('.coupon-wrapper').fadeOut('fast');
      } else {
        jQuery('.coupon-wrapper').fadeIn('fast');
      }
    });

    jQuery(document).on('click', '.prqu-minus', function() {     
      var jQueryinput = jQuery(this).parent().parent().find('input');
      var count = parseInt(jQueryinput.val()) - 1;
      count = count < 1 ? 1 : count;
      jQueryinput.val(count);
      jQueryinput.change();
      jQuery('div.woocommerce > form input[name="update_cart"]').prop('disabled', false);
      
      return false;
    });

    jQuery(document).on('click', '.prqu-plus', function() {
      var jQueryinput = jQuery(this).parent().parent().find('input');
      var max = jQueryinput.attr('max');
      var target = parseInt(jQueryinput.val()) + 1;
      jQueryinput.val(target <= max ? target : target - 1);
      jQueryinput.change();
      jQuery('div.woocommerce > form input[name="update_cart"]').prop('disabled', false);
      
      return false;
    });

    //Page Resize
    jQuery(window).on('resize', this.adjustViewSize);
    setTimeout(() => {
      this.adjustViewSize();
    }, 600);
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/cart.js